import React from 'react';

import {MaybeArchivableItem} from 'archive/ArchiveConstants';
import isArchived from 'archive/isArchived';
import {Permissions} from 'auth/PermissionConstants';
import BufferOptions from 'buffers/BufferOptions';
import {canUserEditAnyPropertiesForStorable} from 'samples/SampleUtil';
import APIUtil from 'util/APIUtil';
import {typeToName} from 'util/NameUtil';

export interface StorableBannerProps {
  isWritable: boolean;
  storable: MaybeArchivableItem & {permissions: Permissions};
}

export default function StorableBanner(props: StorableBannerProps): JSX.Element | null {
  if (props.isWritable) {
    return null;
  }
  const hasPartialEditPerms = canUserEditAnyPropertiesForStorable(props.storable);
  const storableTypeName = typeToName(APIUtil.apiIdToType(props.storable.id));
  let editingLimitedBanner: string;
  if (isArchived(props.storable)) {
    editingLimitedBanner = `Editing disabled on archived ${storableTypeName}.`;
  } else if (hasPartialEditPerms) {
    editingLimitedBanner = `Some actions are disabled because you have insufficient permissions for this ${storableTypeName}.`;
  } else {
    editingLimitedBanner = `Editing disabled on read-only ${storableTypeName}.`;
  }
  return <BufferOptions banner={editingLimitedBanner} />;
}
